/*
 * Created with vue 2
 * Author: cash/jaytanweb@163.com
 * Date: 07/03/2018
 * Time: 17:00
 */
<template>
  <div id='alert' :class="maskState.mask" class="alerts">
    <div class="nav clearfix" :class="maskState.navClass">
      <div class="nav-bg">
        <ul class="nav-btn">
          <li class="logo"></li>
          <li>코에이 테크모 인증</li>
          <li><a href='#part3'>사전등록</a></li>
          <li><a href="#part6">룰렛 이벤트</a></li>
          <li><a href="#part8">게임소개</a></li>
        </ul>
        <!-- <div class="fb-share-button" data-href="https://sangokushi.bbgamekr.com/event" data-layout="button_count" data-size="large" data-mobile-iframe="true"><a target="_blank" href="https://www.facebook.com/sharer/sharer.php?u=https%3A%2F%2Fsangokushi.bbgamekr.com%2Fevent&amp;src=sdkpreparse" class="fb-xfbml-parse-ignore">分享</a></div> -->
      </div>
      <div class="nav-close" @click="clickBtn()"></div>
    </div>
    <div class='video' v-if="maskState.video">
      <div class="close" @click="clickBtn()"></div>
      <iframe width="100%" height="100%" src="https://www.youtube.com/embed/8EFpyOseRGM?rel=0" frameborder="0" allow="autoplay; encrypted-media" allowfullscreen></iframe>
    </div>
    <!-- <div class="bar" v-if="maskState.bar">
      <div class="close" @click="clickBtn()"></div>
      <div class="no-active"></div>
      <div class="ac-bar" :class="circleProgress">
        <div class="ac-active"></div>
      </div>
      <div class="bar-light" :class="circleProgress"></div>
    </div> -->
    <div class="frame" :class="maskState.frame">
      <div class="close" @click="clickBtn()"></div>
      <ul class="frame-bg">
        <li>
          <p v-for="(item, index) in maskState.content" :key='index'>{{item}}</p>
        </li>
      </ul>
    </div>
    <div class="big-frame" :class="maskState.bigFrame">
      <div class="close" @click="clickBtn()"></div>
        <div class="frame-bg">
          <ul>
            <li v-for="(item1, index) in maskState.text" :key='index'>
              <span>{{item1.time}}</span> <span>{{item1.content}}</span> <span>{{item1.redeem_code}}</span>
            </li>
          </ul>
          <nav class="paging">
            <!-- <a href="javascript:;" v-for="(num, index) in maskState.text.allpage" :key="index">{{num}}</a> -->
            <a href="javascript:;" v-for="index in pageings.paging" @click="goto(index)" :class="{'active':pageings.current == index}" :key="index">{{index}}</a>
          </nav>
        </div>
    </div>
    <div class="reward" :class="maskState.reward">
      <div class="close" @click="clickBtn()"></div>
      <div class="frame">
        <input type="text" maxlength="11" class="phone-text" v-model='phone' placeholder="01XXXXXXXXX">
        <span :class="errors">정확한 전화번호를 입력해주세요.</span>
        <a href="javascript:;" class="confirm" @click="bind_nunber()"></a>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState, mapMutations } from 'vuex'
export default {
  name: 'headers',
  data () {
    return {
      errors: '',
      phone: ''
    }
  },
  computed: {
    ...mapState([
      'circleProgress',
      'maskState',
      'pageings'
    ])
  },
  components: {
  },
  watch: {
    phone (n, o) {
      this.phone = n.replace(/[^0-9.]/g, '')
    }
  },
  methods: {
    ...mapMutations([
      'clickHide',
      'clickBtn',
      'pageBtn'
    ]),
    bind_nunber: function () {
      let that = this
      let $ = that.$
      let num = $('.phone-text').val()
      that.errors = ''
      if (/^(01)\d{9}$/.test(num)) {
        let data = {'user_id': that.$lib.getCookie('userID'), '__': that.$lib.getCookie('jwt'), 'number': num}
        let number = $.ajax({url: `https://cgi.bbgame.com.tw/v1/area-kr/sgz/reg.shtml`, dataType: 'jsonp', jsonp: 'callback', data: data})
        number.then(function (res) {
          if (res.status === 0) {
            that.$lib.setCookie('bind', 1, 7)
            that.clickBtn()
            $('#gogogo').click()
          }
        })
      } else {
        that.errors = 'active'
      }
    },
    goto: function (index) {
      let that = this.pageings
      let z = this
      let a = that.currentOne
      let $ = z.$
      if (index === 0) {
      } else if (index === a) {
      } else if (index > that.allpage) {
      } else {
        let data = {'user_id': z.$lib.getCookie('userID'), '__': z.$lib.getCookie('jwt'), page: index}
        // let data = {'user_id': '232753607284274', '__': 'eyJ0eXAiOiJKV1QiLCJhbGciOiJIUzI1NiJ9.eyJ1c2VyX2lkIjoiMjMyNzUzNjA3Mjg0Mjc0IiwiY3JlYXRlZF90aW1lIjoiMTUyNDc5NDAwMTk0NjUyMzI2In0.PZhnmG0yfif5DMiIsKzY7t-kd7rurz0b0vNd9Lg6qVY',page: index}
        let reward = $.ajax({url: `https://cgi.bbgame.com.tw/v1/area-kr/sgz/reward.shtml`, dataType: 'jsonp', jsonp: 'callback', data: data})
        reward.then(function (res) {
          if (res.status === 0) {
            z.list = []
            console.log(res)
            let data = res.message
            console.log(data)
            for (let i = 0; i < data.data.length; i++) {
              let b = []
              b.time = data.data[i].created_time
              b.redeem_code = data.data[i].redeem_code
              b.content = data.data[i].content
              z.list.push(b)
            }
            let c = {
              'allpage': data.pages,
              'current': index,
              'currentOne': index
            }
            z.pageBtn(c)
          }
          let a = {
            0: 'bigFrame',
            'text': z.list
          }
          z.clickBtn(a)
        })
      }
      // 这里可以发送ajax请求
    }
    // ,
    // numbers: function () {
    //   let $ = this.$
    //   $('.phone-text').keydown(function () {
    //     $(this).val($(this).val().replace(/[^0-9.]/g, ''))
    //   })
    // }
  },
  mounted: function () {
    console.log('-- alert mounted --')
    // this.$lib.addC4M('alerts', 'alert-mobile')
  }
}
</script>

<style type="text/scss" lang="scss" scoped>
#alert {
  //begin you code
  background: transparent;
  position: fixed;
  display:flex;
  justify-content: center;
  align-items: center;
  left: 0;
  top: 0;
  right: 0;
  bottom: 0;
  z-index:-1;
  &{
    transition:all .5s;
    &.mask-active{
      background: rgba(0,0,0,.5);
      z-index: 4;
    }
  }
  .nav{
    position:absolute;
    left: -2.94rem;
    top: 0;
    height: 6.67rem;
    width: 2.94rem;
    transition: all .5s;
    &.nav-active{
      left: 0;
    }
    .nav-bg{
      float:left;
      width:2.44rem;
      height: 6.67rem;
      background: url(../assets/images/event/header/nav.png)no-repeat;
      background-size:contain;
      .nav-btn{
        padding-top:.65rem;
        .logo{
          width: 2rem;
          height: .9rem;
          background: url(../assets/images/event/part1/logo.png)no-repeat;
          background-size:contain;
          margin:  0 auto;
        }
        li{
          color: #c9c9c9;
          font-size: .2rem;
          &:nth-of-type(2){
            pointer-events: none;
          }
        }
        li:not(:first-child){
          width: 2rem;
          height: .71rem;
          line-height:.71rem;
          margin: 0 auto;
          text-align:center;
          a{
            display:block;
            color:#C9C9C9;
            transition: color .5s;
            font-size: .15rem;
            font-weight: bold;
            letter-spacing: .02rem;
            @media screen and (min-width:1024px){
              &:hover{
                color:#e4c781;
              }
            }
          }
        }
      }
    }
    .nav-close{
      float:right;
      background: url(../assets/images/event/header/close.jpg)no-repeat;
      background-size:contain;
      width: .41rem;
      height: .41rem;
      margin-top: .16rem;
      cursor: pointer;
      transition: background .5s;
      @media screen and (min-width:1024px){
        &:hover{
          background: url(../assets/images/event/header/close_hover.jpg)no-repeat;
          background-size:contain;
        }
      }
    }
  }
  .video{
    position: relative;
    width: 14rem;
    height: 8rem;
    .close{
      left: 97%;
    }
  }
  // .bar{
  //   width: 9rem;
  //   height: 1.86rem;
  //   background: url(../assets/images/event/alert/alert_login_bg.png)no-repeat;
  //   background-size:contain;
  //   position: relative;
  //   padding-top:.56rem;
  //   .no-active{
  //     width:7.34rem;
  //     height: .8rem;
  //     margin: 0 auto;
  //     background: url(../assets/images/event/part2/arrow_dark.png)no-repeat center;
  //     background-size:contain;
  //   }
  //   .bar-light{
  //     position: absolute;
  //     left: 1.6rem;
  //     top: .92rem;
  //     width: .3rem;
  //     height: .3rem;
  //     background: url(../assets/images/event/part2/arrow_dark_light.gif)no-repeat;
  //     background-size:contain;
  //     opacity: 0;
  //     transition: all 2s;
  //     &.gifts-10wan{
  //       left: 3rem;
  //       opacity: 1;
  //     }
  //     &.gifts-30wan{
  //       left: 4.8rem;
  //     }
  //     &.gifts-50wan{
  //       left: 6.9rem;
  //       opacity: 0;
  //     }
  //   }
  //   .ac-bar{
  //     position:absolute;
  //     left: .83rem;
  //     top: .56rem;
  //     width: 0;
  //     height: .8rem;
  //     transition:all 2s;
  //     overflow:hidden;
  //     &.gifts-10wan{
  //       width: 26%;
  //     }
  //     &.gifts-30wan{
  //       width: 46%;
  //     }
  //     &.gifts-50wan{
  //       width: 100%;
  //     }
  //     .ac-active{
  //       width: 7.34rem;
  //       height: .8rem;
  //       background: url(../assets/images/event/part2/arrow_gold.png)no-repeat center;
  //       background-size:contain;
  //     }
  //   }
  // }
  .close{
    position: absolute;
    background: url(../assets/images/event/header/close.jpg)no-repeat;
    background-size:contain;
    width: .41rem;
    height: .41rem;
    left: 90%;
    top: -.5rem;
    cursor: pointer;
    transition: background .5s;
    @media screen and (min-width:1024px){
      &:hover{
        background: url(../assets/images/event/header/close_hover.jpg)no-repeat;
        background-size:contain;
      }
    }
  }
  .frame{
    height: 2.96rem;
    width: 5.01rem;
    position: absolute;
    opacity: 0;
    transition: all .5s;
    z-index: -1;
    &.active{
      opacity: 1;
      position: relative;
      z-index: 1;
    }
    .frame-bg{
      height: 100%;
      width: 100%;
      background: url(../assets/images/event/header/alert_bg.jpg)no-repeat;
      background-size:contain;
      padding-top:.67rem;
      li{
        text-align:center;
        font-size: .31rem;
        p{
          margin-bottom: .17rem;
        }
      }
    }
  }
  .big-frame{
    width: 9.78rem;
    height: 6.5rem;
    position: absolute;
    opacity: 0;
    transition:  all .5s;
    z-index: -1;
    &.active{
      opacity: 1;
      position: relative;
      z-index: 1;
    }
    .close{
      left:95%;
    }
    .frame-bg{
      background: url(../assets/images/event/alert/frame_420.jpg)no-repeat;
      background-size: contain;
      width: 100%;
      height: 6.95rem;
      padding-top: 1.5rem;
      text-align: center;
      ul{
        height: 3.9rem;
        li{
          width: 7.02rem;
          margin: 0 auto 0 1.45rem;
          text-align:left;
          span{
            display: inline-block;
            width: 1.98rem;
            font-size: .22rem;
            &:nth-of-type(1){
              padding-left: .05rem;
            }
            &:nth-of-type(2){
              text-align: center;
              width: 2.86rem;
            }
            &:nth-of-type(3){
              text-align: right;
              width: 1.93rem;
            }
          }
          &:not(:last-child){
            margin-bottom: .08rem;
          }
          h3{
            font-size: .27rem;
            margin-bottom: .11rem;
          }
          p{
            font-size: .21rem;
            &:not(:last-child){
              margin-bottom: .08rem;
            }
          }
        }
      }
    }
    .paging{
      width: 6rem;
      margin: 0 auto;
      a{
        transition: all .5s;
        color: #a57818;
        display: inline-block;
        margin: 0 .1rem;
        &:hover,&.active{
          color: #e6b54c;
        }
      }
    }
  }
  .reward{
    height: 4.54rem;
    width: 5.67rem;
    position: absolute;
    z-index: -1;
    opacity: 0;
    transition: all .5s;
    &.active{
      z-index: 1;
      opacity: 1;
      position: relative;
      .frame{
        opacity: 1;
      }
    }
    .frame{
      width: 100%;
      height: 4.91rem;
      background: url(../assets/images/event/lottery/result.jpg)no-repeat;
      background-size: contain;
      padding-top: .95rem;
      input{
        height: .59rem;
        display: block;
        width: 3.26rem;
        margin: 0 auto 2rem;
        background: #ddd;
        color:#5a5a5a;
        border: .01rem solid #787777;
        font-size: .25rem;
        text-align: center;
      }
      span{
        display:block;
        text-align: center;
        letter-spacing: .01rem;
        font-size: .2rem;
        height: .3rem;
        color: #f00;
        opacity: 0;
        transition: all .5s;
        &.active{
          opacity: 1;
        }
      }
      .confirm{
        display: block;
        width: 1.31rem;
        height: .49rem;
        margin: 0 auto;
        background: url(../assets/images/event/lottery/confirm.png);
        background-size: contain;
        transition: all .5s;
        @media screen and (min-width:1024px){
          &:hover{
            background: url(../assets/images/event/lottery/confirm_hover.png);
            background-size: contain;
          }
        }
      }
    }
  }
}
@media screen and (max-width:1024px){
  #alert{
    .close{
      width: .77rem;
      height: .77rem;
      left: 86%;
      top:-.8rem;
    }
    .frame{
      width: 6.31rem;
      height: 3.74rem;
      .frame-bg{
        padding-top: 1.23rem;
      }
    }
    .video{
        width: 7rem;
        height: 4rem;
        .close{
          left: 89%;
        }
      }
    .big-frame{
      width: 6.88rem;
      height: 9.8rem;
      padding-top: .94rem;
      .close{
        top: 0;
        left: 88%;
      }
      .frame-bg{
        background: url(../assets/images/event/4mobile/frame_420_mb.jpg)no-repeat;
        background-size: contain;
        width: 100%;
        height: 8.86rem;
        padding-top: 2.38rem;
        ul{
          height: 5.1rem;
          li{
            width: 5.89rem;
            font-size: .2rem;
            margin: 0 auto 0 .53rem;
            span{
              &:nth-of-type(1){
                padding-left: .12rem;
                width: 1.42rem;
              }
              &:nth-of-type(2){
                width: 2.88rem;
              }
              &:nth-of-type(3){
                width: 1.45rem;
              }
            }
            &:not(:last-child){
              margin-bottom: .2rem;
            }
            p:not(:last-child){
              margin-bottom:.22rem;
            }
          }
        }
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/event/alert.vue